import React from 'react';
import { Switch, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AddModal from './components/common/AddModal';
import Sidebar from './components/common/Sidebar';
import MainIndex from './screens/MainIndex';
import SignIn from './components/Auth/SignIn';
import AuthLeft from './components/Auth/AuthLeft';


function App(props) {
    const { isAuthenticated } = useSelector(state => state.Mainreducer);

    const activekey = () => {
        var res = window.location.pathname
        var baseUrl = process.env.PUBLIC_URL
        res = res.split("/");
        res = res.length > 0 ? res[baseUrl.length] : "/";
        res = res ? "/" + res : "/";
        const activeKey1 = res;
        return activeKey1
    }

    if (!isAuthenticated) {
        return (
            <div
                id="ebazar-layout"
                className="theme-blue"
                style={{
                    display: 'flex',
                    minHeight: '100vh',
                    margin: 0,
                    padding: 0
                }}
            >
                <AuthLeft />
                <SignIn />
            </div>
        );
    } else {
        return (
            <div id="ebazar-layout" className='theme-blue'>
                <Sidebar activekey={activekey()} history={props.history} />
                <AddModal />
                <Switch>
                    <MainIndex activekey={activekey()} />
                </Switch>
            </div>
        )
    }
}
export default withRouter(App);
